import Input from '@repo/ui/input'
import RadioInput from '@repo/ui/radio-input'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../lib/hooks/use-translate'
import { HostFamilyFilters } from '../../../lib/types/models/host-family/host-family'

interface Props {
  filter?: HostFamilyFilters
  onFilterChange: (filter: HostFamilyFilters) => void
}

export function HostFamilyFilter({ filter, onFilterChange }: Props) {
  function setFilter<K extends keyof HostFamilyFilters>(key: K, value: HostFamilyFilters[K]) {
    onFilterChange({ ...filter, [key]: value })
  }

  const { t } = useTranslate()

  return (
    <div className={'flex flex-col gap-4'}>
      <div className={'flex flex-col gap-2'}>
        <Typography variant={'label-semibold'}>{t('host.family.filters.status.label')}</Typography>

        <div className="flex flex-row gap-5">
          <RadioInput
            label={t('host.family.filters.status.both')}
            checked={filter?.deactivated === undefined}
            onCheck={() => setFilter('deactivated', undefined)}
          />

          <RadioInput
            label={t('host.family.filters.status.deactivated')}
            checked={filter?.deactivated === true}
            onCheck={() => setFilter('deactivated', true)}
          />

          <RadioInput
            label={t('host.family.filters.status.active')}
            checked={filter?.deactivated === false}
            onCheck={() => setFilter('deactivated', false)}
          />
        </div>
      </div>

      <Input
        type="text"
        label={t('host.family.filters.town.label')}
        value={filter?.city}
        onChange={(event) => setFilter('city', event.target.value)}
      />

      <div className={'flex flex-col gap-2'}>
        <Typography variant={'label-semibold'}>
          {t('host.family.filters.lec.comments.label')}
        </Typography>

        <div className="flex flex-row gap-5">
          <RadioInput
            label={t('host.family.filters.lec.comments.both')}
            checked={filter?.hasComments === undefined}
            onCheck={() => setFilter('hasComments', undefined)}
          />

          <RadioInput
            label={t('host.family.filters.lec.comments.has')}
            checked={filter?.hasComments === true}
            onCheck={() => setFilter('hasComments', true)}
          />

          <RadioInput
            label={t('host.family.filters.lec.comments.no')}
            checked={filter?.hasComments === false}
            onCheck={() => setFilter('hasComments', false)}
          />
        </div>
      </div>

      <div className={'flex flex-col gap-2'}>
        <Typography variant={'label-semibold'}>
          {t('host.family.filters.date.of.visit.label')}
        </Typography>

        <div className="flex flex-row gap-5">
          <RadioInput
            label={t('host.family.filters.date.of.visit.all')}
            checked={filter?.dateOfVisit === undefined}
            onCheck={() => setFilter('dateOfVisit', undefined)}
          />

          <RadioInput
            label={t('host.family.filters.date.of.visit.has')}
            checked={filter?.dateOfVisit === true}
            onCheck={() => setFilter('dateOfVisit', true)}
          />

          <RadioInput
            label={t('host.family.filters.date.of.visit.no')}
            checked={filter?.dateOfVisit === false}
            onCheck={() => setFilter('dateOfVisit', false)}
          />
        </div>
      </div>
    </div>
  )
}
